import React, { useState } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import Navbar from '../components/accueil/Navbar';
import PageBanner from './Banner';
import Footer from '../components/accueil/Footer';
import ChatWidget from '../components/accueil/ChatWidget';
import useGlobale from '../components/global';

const FaqScreen = () => {
  const { authenticated, user, logout } = useGlobale();
  const [searchTerm, setSearchTerm] = useState('');
  const [openCategory, setOpenCategory] = useState('general');
  const [openQuestions, setOpenQuestions] = useState(new Set());

  const faqData = {
    general: {
      title: "Questions Générales",
      questions: [
        {
          id: 'q1',
          question: "Qu'est-ce que Niger Voyage ?",
          answer: "Niger Voyage est une plateforme de suivi des voyages entrants et sortants du Niger. Elle permet de gérer et suivre tous les déplacements des voyageurs à destination ou en provenance du Niger."
        },
        {
          id: 'q2',
          question: "Comment créer un compte ?",
          answer: "Pour créer un compte, cliquez sur le bouton 'S'inscrire' en haut de la page. Remplissez le formulaire avec vos informations personnelles et suivez les instructions pour valider votre compte."
        },
      ]
    },
    reservations: {
      title: "Réservations et Voyages",
      questions: [
        {
          id: 'q3',
          question: "Comment enregistrer un nouveau voyage ?",
          answer: "Pour enregistrer un nouveau voyage, connectez-vous à votre compte, accédez à la section 'Voyages' et cliquez sur 'Nouveau Voyage'. Remplissez les informations requises et validez l'enregistrement."
        },
        {
          id: 'q4',
          question: "Quels documents sont nécessaires ?",
          answer: "Les documents requis incluent un passeport valide, un visa si nécessaire, et tout autre document spécifique selon le type de voyage et la destination."
        },
      ]
    },
    securite: {
      title: "Sécurité et Confidentialité",
      questions: [
        {
          id: 'q5',
          question: "Comment mes données sont-elles protégées ?",
          answer: "Vos données sont cryptées et stockées de manière sécurisée selon les normes internationales de protection des données. Nous respectons strictement les règles de confidentialité."
        },
        {
          id: 'q6',
          question: "Qui a accès à mes informations ?",
          answer: "Seul le personnel autorisé a accès à vos informations, et uniquement dans le cadre de leurs fonctions. Vos données ne sont jamais partagées avec des tiers sans votre consentement."
        },
      ]
    }
  };

  const toggleCategory = (category) => {
    setOpenCategory(openCategory === category ? null : category);
  };

  const toggleQuestion = (questionId) => {
    const newOpenQuestions = new Set(openQuestions);
    if (newOpenQuestions.has(questionId)) {
      newOpenQuestions.delete(questionId);
    } else {
      newOpenQuestions.add(questionId);
    }
    setOpenQuestions(newOpenQuestions);
  };

  const filterQuestions = () => {
    if (!searchTerm) return faqData;

    const filteredData = {};
    Object.entries(faqData).forEach(([category, data]) => {
      const filteredQuestions = data.questions.filter(
        q => q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
             q.answer.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (filteredQuestions.length > 0) {
        filteredData[category] = {
          ...data,
          questions: filteredQuestions
        };
      }
    });
    return filteredData;
  };

  return (
    <>
      <Navbar authenticated={authenticated} user={user} logout={logout} />
      <PageBanner currentPage="FAQ" />
      
      <div className="min-h-[calc(100vh-450px)] bg-gray-50 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Barre de recherche */}
          <div className="mb-8">
            <div className="relative">
              <input
                type="text"
                placeholder="Rechercher une question..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-3 pl-12 border border-gray-300 rounded-xl
                          focus:ring-2 focus:ring-brand-500 focus:border-brand-500
                          transition-all duration-200 ease-in-out"
              />
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            </div>
          </div>

          {/* Questions FAQ */}
          <div className="space-y-6">
            {Object.entries(filterQuestions()).map(([category, data]) => (
              <div key={category} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                {/* En-tête de catégorie */}
                <button
                  onClick={() => toggleCategory(category)}
                  className={`w-full px-6 py-4 flex items-center justify-between text-left 
                             ${openCategory === category ? 'bg-brand-600 text-white' : 'bg-white text-gray-900'}`}
                >
                  <h2 className="text-lg font-semibold">{data.title}</h2>
                  <ChevronDown
                    className={`transform transition-transform duration-200 ${
                      openCategory === category ? 'rotate-180' : ''
                    }`}
                    size={20}
                  />
                </button>

                {/* Questions de la catégorie */}
                {openCategory === category && (
                  <div className="border-t border-gray-100">
                    {data.questions.map((item) => (
                      <div key={item.id} className="border-b border-gray-100 last:border-0">
                        <button
                          onClick={() => toggleQuestion(item.id)}
                          className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50"
                        >
                          <h3 className="font-medium text-gray-900 pr-8">{item.question}</h3>
                          <ChevronDown
                            className={`transform transition-transform duration-200 flex-shrink-0 text-gray-400 ${
                              openQuestions.has(item.id) ? 'rotate-180' : ''
                            }`}
                            size={16}
                          />
                        </button>
                        {openQuestions.has(item.id) && (
                          <div className="px-6 py-4 bg-gray-50">
                            <p className="text-gray-600">{item.answer}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
      <ChatWidget />
    </>
  );
};

export default FaqScreen;